import { render, staticRenderFns } from "./ExclusiveGuide.vue?vue&type=template&id=3680b7bc&scoped=true"
import script from "./ExclusiveGuide.vue?vue&type=script&lang=js"
export * from "./ExclusiveGuide.vue?vue&type=script&lang=js"
import style0 from "./ExclusiveGuide.vue?vue&type=style&index=0&id=3680b7bc&prod&scoped=true&lang=css"
import style1 from "./ExclusiveGuide.vue?vue&type=style&index=1&id=3680b7bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680b7bc",
  null
  
)

export default component.exports